


import { defineComponent, onMounted, ref, onBeforeUnmount, onUnmounted } from 'vue';
import { MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import PanelTypeConst from '../../../../domain/Constants/PanelTypeConst';
import { Container } from 'inversify';
import BaseControlTypeConst from '../../../../domain/Constants/BaseControlTypeConst';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import { IapCatalogType } from '../../../../../catalog/domain/iapCatalogType';
import { Dictionary } from '../../../../../expression/domain/dictionary';
import { useStore } from 'vuex';	

export default defineComponent({
    name: 'dynamic_panel',
    props:
    {

        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        },
    },
    setup(props, context) {
        //       
        const store = useStore();
        const { vmodel, loaded, getPropertyValue, getPropertyBooleanValue, resolveExpressions, baseOnUnmount
            ,fieldKey,fieldKeyComponentDataSourceId } = ComponentCommon(props, context,store);


        const showMessage = (msg: string) => {
            MessageService.showToast(MessageType.Correcto, '', msg)
        }


        //const functions = ref([]);
        onMounted(() => {
            // resolveExpressions();
            //// eval(' showMessage("click del boton"); alert("hola");')
            //alert('hola')
            //clickf.value = new Function('', props.Component.componentAttributes[0].componentAttributeEvent?.code as any);
            //clickf.value = new Function('', eval(' showMessage("click del boton");'))
            //MessageService.showToast(MessageType.Correcto, '', 'Se ha enviado el correo de reestablecimiento de contraseña correctamente.');
            //functions.value.push(f as any)
            //= '';
            //Components
            //clickf.value()
        })

        onUnmounted(() => {
            baseOnUnmount();
        })


        return {
            MessageService,
            MessageType,
            showMessage,
            getPropertyValue,
            getPropertyBooleanValue,
            vmodel,
            PanelTypeConst,
            loaded,
            BaseControlTypeConst,
            fieldKey,
            fieldKeyComponentDataSourceId
        };
    },
});
